import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="container container--space-y">
      <h1>404 Not Found</h1>
      <Link to="/">Back home</Link>
    </div>
  );
};

export default NotFoundPage;
